export const CLAIMS_DASHBOARD: string = 'dashboard';
export const CLAIMS_LIST: string = 'list';
export const CLAIMS_HOME: string = 'home';
export const CLAIM_DETAIL: string = 'detail';
export const CLAIM_NEW: string = 'new';
export const CLAIM_DRAFT: string = 'draft';
export const CLAIM_INCOMPLETE: string = 'incomplete';
export const CREATE_CLAIM_WITH_COUNTERPART: string = 'with-counterpart';
export const CREATE_CLAIM_WITHOUT_COUNTERPART: string = 'without-counterpart';
export const CREATE_ROBBERY: string = 'robbery';
export const CLAIMS_REPAIR: string = 'repair';
export const CLAIMS_THEFT: string = 'theft';
export const CLAIMS_LOGIN: string = 'login';
export const CLAIMS_TABLE: string = 'table';
export const CLAIMS_UTILITY: string = 'utility';
export const CLAIMS_SETTINGS: string = 'settings';
export const CLAIMS_DATA_MANAGEMENT: string = 'data-management';
export const CLAIMS_SUPPLIER: string = 'supplier';
export const CLAIMS_COMPANY: string = 'company';
export const CLAIMS_MANAGER: string = 'manager';
export const CLAIMS_MANAGER_REPAIR: string = 'manager-repair';
export const CLAIMS_LEGAL: string = 'legal';
export const CLAIMS_INSPECTORATE: string = 'inspectorate';
export const CLAIMS_RECIPIENT: string = 'recipient';
export const CLAIMS_EVENT: string = 'event';
export const CLAIMS_MOTIVATION: string = 'motivation';
export const CLAIMS_POLICY: string = 'policy';
export const CLAIMS_EMAIL_TEMPLATE: string = 'email-template';
export const CLAIMS_ANTI_THEFT: string = 'anti-theft';
export const CLAIMS_EVIDENCE_REQUEST: string = 'evidence-request';
export const CLAIMS_RECOVERABILITY: string = 'recoverability';
export const CLAIMS_NOTIFICATION: string = 'notification';
export const CLAIMS_ATTACHMENT: string = 'attachment';
export const CLAIMS_PERSONAL: string = 'personal';
export const CLAIMS_EXPORT_ACCIDENT_TYPE: string = 'export-accident-type';
export const CLAIMS_EXPORT_NOTIFICATION_TYPE: string = 'export-notification-type';
export const CLAIMS_EXPORT_STATUS_TYPE: string = 'export-status-type';
export const CLAIMS_EXPORT_SUPPLIER_CODE: string = 'export-supplier-code';
export const CLAIMS_CONTRACT_SETTINGS: string = 'contract-settings';
export const CLAIM_SELECT_PLATE: string = 'select-plate';
export const CLAIM_LOG: string = 'log';
export const CLAIMS_IMPORT: string = 'import';
export const CLAIMS_EXPORT: string = 'export';
export const CLAIM_REDIRECT: string = 'redirect';
export const CLAIMS_GENERAL_EXEMPTION: string = 'general-exemption';

export const CLAIMS_PRACTICE: string = 'practice';
export const CLAIMS_PRACTICE_LIST: string = 'practices';
export const CLAIMS_PRACTICE_NEW: string = 'practice-new';
export const CLAIMS_PRACTICE_DETAILS: string = 'practice-details';

export const CLAIMS_CONFIGURATION_MODULES: string = 'configuration-modules';
export const CLAIMS_SYSTEM_TABLES: string = 'system-tables';
export const CLAIMS_REPAIRER: string = 'repairer';
export const CLAIMS_GENERIC_ATTACHMENT: string = 'generic-attachment';
export const CLAIMS_WORKING: string = 'working';
export const CLAIMS_MYALD_REDIRECT: string = 'myald-redirect';

